import { Koi } from '@ksyos/koi';
import { replaceKoiError } from '../replaceKoiError';

export const minimumAcceptedLengthBigCode = 9;
export const maximumAcceptedLengthBigCode = 11;

const identifierRegistrationBigRegExpFrontend = new RegExp(
    `^[0-9]{${minimumAcceptedLengthBigCode},${maximumAcceptedLengthBigCode}}$`
);

export const identifierRegistrationBigFrontendSchema = Koi.string()
    .allow(null)
    .regex(identifierRegistrationBigRegExpFrontend)
    .error((errors) =>
        replaceKoiError(errors, 'string.pattern.base', 'identifierRegistrationBigNumberRequiredFrontend')
    );

const identifierRegistrationBigRegExpBackend = new RegExp(`^[0-9]{${maximumAcceptedLengthBigCode}}$`);

export const identifierRegistrationBigBackendSchema = Koi.string()
    .allow(null)
    .regex(identifierRegistrationBigRegExpBackend)
    .error((errors) =>
        replaceKoiError(errors, 'string.pattern.base', 'identifierRegistrationBigNumberRequiredBackend')
    );

export const agbCodeSchema = Koi.string()
    .length(8)
    .regex(/^[0-9]{8}$/)
    .error((errors) => replaceKoiError(errors, 'string.pattern.base', 'agbCodeRequired'));

export const identifierRegistrationKpSchema = Koi.string()
    .length(11)
    .regex(/^[0-9]{11}$/)
    .error((errors) => replaceKoiError(errors, 'string.pattern.base', 'identifierRegistrationKpNumberRequired'));
